// LIBRARY
import React from 'react';

// CUSTOM
import StepPage from '../steps';

class EditRequestPage extends React.Component {
	render() {
		return (
			<div>
				<StepPage moduleType="edit" />
			</div>
		);
	}
}

export default EditRequestPage;
